import "./OurPeopleDetail.scss";
import Section from "../../modules/section/Section";
import Picture from "../../atoms/picture/Picture";
import OurPeopleDetailData from "./OurPeopleDetailData.json";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

const OurPeopleDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const person = OurPeopleDetailData.people.find((person) => person.id === id);
  const [mainImage, setMainImage] = useState(null);

  useEffect(() => {
    if (person) {
      import(`../../../assets/images/${person.image}`).then((data) => {
        setMainImage(data);
      });
    }
  }, [person]);

  if (!person) {
    return <h2 className="container mb-sm">{t("noPage")}</h2>;
  }

  return (
    <div className={"our-people-detail"}>
      <div className={"container mb-sm header-container"}>
        <h2>{t(person.name)}</h2>
        {person.email && (
          <a
            className={"text-primary underline-primary"}
            href={`mailto:${person.email}`}
          >
            {person.email}
          </a>
        )}
      </div>
      <div className={"our-people-detail__content"}>
        <Section className={"our-people-detail__picture"}>
          {mainImage && (
            <div className={"relative"}>
              <Picture
                srcDesktop={mainImage.default}
                srcMobile={mainImage.default}
              />
            </div>
          )}
        </Section>
        <Section>
          {person.content.map((section) => {
            return (
              <div key={section.title} className={"content-grid-card"}>
                <div>{t(section.description)}</div>
              </div>
            );
          })}
        </Section>
      </div>
    </div>
  );
};

export default OurPeopleDetail;
